var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1275_867)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13C13.931 13 14.3443 12.8288 14.649 12.524L24.399 2.77405C25.0337 2.13945 25.0337 1.11055 24.399 0.475951C23.7644 -0.158651 22.7356 -0.158651 22.101 0.475951L13.5 9.0769L4.89905 0.475951C4.26445 -0.158651 3.23555 -0.158651 2.60095 0.475951C1.96635 1.11055 1.96635 2.13945 2.60095 2.77405L12.351 12.524C12.6557 12.8288 13.069 13 13.5 13Z",
    fill: "url(#paint0_linear_1275_867)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13C13.931 13 14.3443 12.8288 14.649 12.524L24.399 2.77405C25.0337 2.13945 25.0337 1.11055 24.399 0.475951C23.7644 -0.158651 22.7356 -0.158651 22.101 0.475951L13.5 9.0769L4.89905 0.475951C4.26445 -0.158651 3.23555 -0.158651 2.60095 0.475951C1.96635 1.11055 1.96635 2.13945 2.60095 2.77405L12.351 12.524C12.6557 12.8288 13.069 13 13.5 13Z",
    fill: "#C57F19",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6768 9.25368C13.6299 9.30056 13.5663 9.3269 13.5 9.3269C13.4337 9.3269 13.3701 9.30056 13.3232 9.25368L4.72227 0.652728C4.1853 0.115756 3.3147 0.115756 2.77773 0.652728C2.24076 1.1897 2.24076 2.0603 2.77773 2.59727L12.5277 12.3473C12.7856 12.6051 13.1353 12.75 13.5 12.75C13.8647 12.75 14.2144 12.6051 14.4723 12.3473L24.2223 2.59727C24.7592 2.0603 24.7592 1.1897 24.2223 0.652728C23.6853 0.115756 22.8147 0.115756 22.2777 0.652728L13.6768 9.25368Z",
    stroke: "url(#paint1_linear_1275_867)",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6768 9.25368C13.6299 9.30056 13.5663 9.3269 13.5 9.3269C13.4337 9.3269 13.3701 9.30056 13.3232 9.25368L4.72227 0.652728C4.1853 0.115756 3.3147 0.115756 2.77773 0.652728C2.24076 1.1897 2.24076 2.0603 2.77773 2.59727L12.5277 12.3473C12.7856 12.6051 13.1353 12.75 13.5 12.75C13.8647 12.75 14.2144 12.6051 14.4723 12.3473L24.2223 2.59727C24.7592 2.0603 24.7592 1.1897 24.2223 0.652728C23.6853 0.115756 22.8147 0.115756 22.2777 0.652728L13.6768 9.25368Z",
    stroke: "#C57F19",
    strokeOpacity: 0.4,
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1275_867",
    x: 0.125,
    y: 0,
    width: 26.75,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1275_867"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1275_867",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_867",
    x1: 13.4031,
    y1: 14.8307,
    x2: 13.4031,
    y2: -3.89047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471084,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474255,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1275_867",
    x1: 13.4031,
    y1: 14.8307,
    x2: 13.4031,
    y2: -3.89047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.23deb05e0576c6776f0db0eee3dba544.svg";
export { ForwardRef as ReactComponent };